<template>
    <ColorModeToggler />
    <SearchBar />
    <I18nSwitcher />
</template>
